module.exports = __webpack_public_path__ + "static/img/bg_arrow_link03.9d01d57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg_arrow_link03.png
// module id = zg0W
// module chunks = 10